import type { MembershipAwarenessFormState } from './types';

export function initialState(): MembershipAwarenessFormState {
	return {
		paymentTerm: 'monthly',
	};
}
